module.exports = __webpack_public_path__ + "media/images/icons/edit-6771ece5c340dce00eace776a8d8e5aa.png";